/* eslint-disable sonarjs/cognitive-complexity */
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { BaSeIcon, BaSeStepper } from '@base/react';
import CommonButton from '../../../shared/components/common-button/common-button';
import { useInterviewContext } from '../../../shared/context/interview-context';
import { Layout } from '../../../shared/layout/layout';
import {
  ButtonContainer,
  Container,
  ContainerFinished,
  ContentFinished,
  ContentPanel,
  ContentScrollArea,
  ContentStepper,
  ContentTitleScrollArea,
  LeftPanel,
  MainWrapper
} from './candidate-style';

import { useAnswerController } from '../../../../hooks/controllers/answer-controller';
import { useValidationsContext } from '../../../shared/context/validations-context';
import AccordionInformations from '../../components/accortion-informations/accortion-informations';
import { LeftPanelContent } from '../../components/left-panel-content/left-panel-content';
import {
  INTERVIEW_STEPS,
  INTERVIEW_STEPS_STARTUP,
  QUESTION_TIPS,
  STEP_TEXTS,
  STEP_TEXTS_STARTUP
} from '../../constants/interview-data';
import { useInterviewSteps } from '../../hooks/useInterviewSteps';

const cache = Sebrae.StorageUtil.inPersistentStore();
const cacheTemporary = Sebrae.StorageUtil.inTemporaryStore();

const cacheKey = '@empretec:startedInterview';
const cacheKeyStartup = '@empretec:dataQuestionaireStartup';

const CandidateInterviewNew = () => {
  const { moduleColors, interview, respostas } = useInterviewContext();
  const { isAuthenticated } = Sebrae.useAuth();
  const { navigateTo } = Sebrae.useSebraeRouter();




  const {
    currentStep,
    goToNext,
    goToPrevious,
    activeQuestionId,
    finishedInterview,
    setFinishedInterview,
    setStatusInterview,
    stepContents,
    statusInterview,
  } = useInterviewSteps(interview?.module?.id);

  const { getIsDisabled } = useValidationsContext();

  const currentFrases = React.useMemo(() => {
    return (
      QUESTION_TIPS.find((item) => item.id === activeQuestionId)?.frases || []
    );
  }, [activeQuestionId]);

  const handleStartedInterview = React.useCallback(() => {
    goToNext();
    if (currentStep === 4) {
      cache.setItem(cacheKey, { status: true, code: interview?.id });
    }
  }, [goToNext, currentStep, interview]);

  const { sendAnswerInterview } = useAnswerController();

  const handleSendStartupDataAgain = React.useCallback(async () => {
    if (cacheTemporary.hasItem(cacheKeyStartup)) {
      const data = cacheTemporary.getItem(cacheKeyStartup);

      if (interview.id === data.idInterview) {
        sendAnswerInterview(data, interview?.module?.id)
          .then(() => {
            setFinishedInterview(true);
            setStatusInterview('PROCESSING');
            cacheTemporary.removeItem(cacheKeyStartup);
          })
          .catch((error) => {
            console.error('Erro ao enviar', error);
            setFinishedInterview(true);
            setStatusInterview('ERROR');
          });
      }
    }
  }, [
    interview,
    setFinishedInterview,
    sendAnswerInterview,
    setStatusInterview,
  ]);

  const handleSendAgain = React.useCallback(async () => {
    const payload = {
      idInterview: interview.id,
      answers: respostas,
    };
    try {
      await sendAnswerInterview(payload, interview.module.id);
      setFinishedInterview(true);
      setStatusInterview('PROCESSING');
    } catch (error) {
      console.log(error);
      setFinishedInterview(true);
      setStatusInterview('ERROR');
    }
  }, [
    respostas,
    interview,
    setFinishedInterview,
    sendAnswerInterview,
    setStatusInterview,
  ]);

  const STEPS =
    interview?.module.id === 2 ? INTERVIEW_STEPS_STARTUP : INTERVIEW_STEPS;
  const lastStep = interview?.module.id === 2 ? 4 : 5;
  const isFirstStep = currentStep === 1;

  const getButtonText = () => {
    if (currentStep === 4) {
      return interview?.module.id === 2
        ? 'Iniciar questionário'
        : 'Iniciar minha entrevista';
    }
    return 'Continuar';
  };

  if (!isAuthenticated) {
    console.log(isAuthenticated)
    const url = window.location.protocol + '//' + window.location.host;
    navigateTo(`${url}/`);
    return null
  }


  if (finishedInterview) {
    return (
      <Layout>
        <ContainerFinished fullHeight={currentStep === 1}>

          <LeftPanel backgroundColor={moduleColors?.primary}>
            <div
              style={{
                backgroundColor: '#fff',
                padding: '1em',
                width: '100%',
              }}
            >
              <ContentStepper
                status={statusInterview}
              >

                <BaSeStepper
                  activeColor="#0000C7"
                  completedColor="#008437"
                  uncompletedColor="#0000C7"
                  currentStep={currentStep}
                  onStepChange={() => { }}
                  orientation="horizontal"
                  steps={
                    statusInterview === 'SUCCESS' ||
                      statusInterview === 'PROCESSING'
                      ? STEPS.map((v) => {
                        if (interview?.module.id === 2) {
                          if (v.title === 'Questionário') {
                            return { ...v, isCompleted: true };
                          }
                        }
                        if (v.title === 'Entrevista') {
                          return { ...v, isCompleted: true };
                        }
                        return v;
                      })
                      : STEPS.map((v) => {
                        if (interview?.module.id === 2) {
                          if (v.title === 'Questionário') {
                            return { ...v, isCompleted: true };
                          }
                        }
                        if (v.title === 'Entrevista') {
                          return { ...v, isCompleted: true, withError: true };
                        }
                        return v;
                      })
                  }
                />
              </ContentStepper>

            </div>

            <LeftPanelContent
              interview={interview}
              currentStep={currentStep}
              activeQuestionId={activeQuestionId}
              currentFrases={currentFrases}
              showTips={true}
            />
          </LeftPanel>
          <ContentPanel>
            <ContentScrollArea
              backgroundColor={
                interview?.module.id === 3 && moduleColors?.tertiary
              }
            >
              <ContentFinished>
                <div style={{ display: 'grid', gap: 8, marginBottom: '1em' }}>
                  {interview?.module.id === 2 ? (
                    <strong>Questionário de seleção</strong>
                  ) : (
                    <strong>
                      Você verá 5 situações. Para cada uma, conte um fato real
                      em que você foi o protagonista e de preferência da sua
                      vida empresarial.{' '}
                    </strong>
                  )}
                  {interview?.module.id === 2 ? (
                    <p>
                      Esta etapa consiste em um questionário em que iremos
                      conhecer um pouco mais sobre o perfil da sua startup para
                      assim avaliar sua participação no seminário.
                    </p>
                  ) : (
                    <p>
                      Cada relato deve ter uma estrutura de começo, meio e fim,
                      e você deve escolher histórias que se lembre bem e se
                      sinta à vontade para compartilhar.
                    </p>
                  )}
                </div>

                <div
                  style={{
                    backgroundColor: '#fff',
                    height: '70%',
                    borderRadius: 8,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    {statusInterview === 'ERROR' ? (
                      <div
                        style={{
                          display: 'grid',
                          placeItems: 'center',
                          gap: 8,
                        }}
                      >
                        <BaSeIcon
                          name="exclamation-octagon"
                          size="80"
                          description="icon-times"
                          color="#b82c2c"
                        />
                        <div style={{ display: 'grid', placeItems: 'flex-center', gap: 8, padding: '0 0.5em', maxWidth: '420px' }}>
                          <strong style={{ width: '100%', textAlign: 'center', fontSize: 'larger' }}>
                            {interview?.module.id === 2
                              ? 'Seu questionário não foi enviado'
                              : 'Sua entrevista não foi enviada!'}
                          </strong>

                          <p style={{ width: '100%', textAlign: 'center', margin: 0 }}>
                            Mas não se preocupe, suas respostas estão salvas. Às vezes isso acontece,
                            tente novamente em alguns instantes.
                          </p>
                        </div>
                        <CommonButton
                          variant="primary"
                          isBold={true}
                          backgroundColor="#0000C7"
                          onClick={
                            interview?.module.id === 2
                              ? handleSendStartupDataAgain
                              : handleSendAgain
                          }
                        >
                          {interview?.module.id === 2
                            ? 'Enviar questionário novamente'
                            : 'Enviar entrevista novamente'}
                        </CommonButton>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'grid',
                          placeItems: 'center',
                          gap: 8,
                        }}
                      >
                        <BaSeIcon
                          name="check-circle"
                          description="imagem de check"
                          color={'#008437'}
                          size={80}
                        />
                        <div style={{ display: 'grid', placeItems: 'flex-center', gap: 8, padding: '0 0.5em' }}>
                          <strong style={{ maxWidth: interview?.module.id === 2 ? '410px' : '375px', textAlign: 'center', fontSize: 'larger' }}>
                            {interview?.module.id === 2
                              ? 'Seu questionário foi enviado com sucesso!'
                              : 'Sua entrevista foi enviada com sucesso!'}
                          </strong>

                          <p style={{ maxWidth: '375px', textAlign: 'center', margin: 0 }}>
                            Agradecemos por dedicar seu tempo para realizar {interview?.module.id === 2 ? 'o questionário' : 'a entrevista'} de seleção para o Empretec. Em breve você
                            receberá em seu e-mail o resultado da sua inscrição.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </ContentFinished>
            </ContentScrollArea>
          </ContentPanel>
        </ContainerFinished>
      </Layout>
    );
  }
  return (
    <Layout>
      <MainWrapper>
        <Container fullHeight={currentStep === 1}>
          <LeftPanel backgroundColor={moduleColors?.primary}>
            <div
              style={{
                backgroundColor: '#fff',
                padding: '1em',
                width: '100%',
              }}
            >
              <BaSeStepper
                activeColor="#0000C7"
                completedColor="#008437"
                uncompletedColor="#0000C7"
                currentStep={currentStep}
                onStepChange={() => { }}
                orientation="horizontal"
                steps={STEPS}
              />
            </div>

            <LeftPanelContent
              interview={interview}
              currentStep={currentStep}
              activeQuestionId={activeQuestionId}
              currentFrases={currentFrases}
              showTips={true}
            />
          </LeftPanel>

          <ContentPanel>
            <ContentScrollArea
              backgroundColor={
                interview?.module.id === 3 && moduleColors?.tertiary
              }
            >
              <ContentTitleScrollArea status={statusInterview}>
                <BaSeStepper
                  activeColor="#0000C7"
                  completedColor="#008437"
                  uncompletedColor="#0000C7"
                  currentStep={currentStep}
                  onStepChange={() => { }}
                  orientation="horizontal"
                  steps={STEPS.map((t) => {
                    return { ...t, title: '' };
                  })}
                />
                {interview?.module.id !== 2 && currentStep === 5 && (

                  <AccordionInformations activeQuestionId={activeQuestionId} currentFrases={currentFrases} />
                )}
                {interview?.module.id !== 2 && currentStep !== 5 ? (
                  <p style={{ color: '#0015C1', fontSize: '1.4em' }}>
                    Olá,{' '}
                    <strong>{interview?.candidate.name.split(' ')[0]}</strong>!{' '}
                    {interview?.module.id !== 2
                      ? STEP_TEXTS[currentStep]
                      : STEP_TEXTS_STARTUP[currentStep]}
                  </p>
                ) : (
                  <p style={{ color: '#0015C1', fontSize: '1.4em' }}>
                    Olá,{' '}
                    <strong>{interview?.candidate.name.split(' ')[0]}</strong>
                  </p>
                )}
              </ContentTitleScrollArea>
              {stepContents[currentStep]}
            </ContentScrollArea>
          </ContentPanel>
        </Container>

        {currentStep !== lastStep && (
          <ButtonContainer>
            {!isFirstStep && (
              <CommonButton
                variant="secondary"
                foregroundColor="#0015C1"
                isBold={true}
                backgroundColor="#0000C7"
                onClick={goToPrevious}
              >
                Voltar
              </CommonButton>
            )}
            <CommonButton
              variant="primary"
              isBold={true}
              disabled={getIsDisabled(currentStep)}
              style={{ marginLeft: isFirstStep ? 'auto' : '' }}
              backgroundColor="#0000C7"
              onClick={handleStartedInterview}
            >
              {getButtonText()}
            </CommonButton>
          </ButtonContainer>
        )}
      </MainWrapper>
    </Layout>
  );
};

export default CandidateInterviewNew;
